(function () {
    function CurrentCampaignsController(
        $scope,
        $filter,
        $uibModal,
        PermissionService,
        CampaignsService,
        LocalisationService,
        ErrorService,
        notify,
        $state,
        $window,
        NgTableParams,
        DashboardConfig
    ) {
        const self = this;

        /**
         * Initialises the controller and sets up the scope variables, permissions and grids
         */
        self.initialise = function () {
            self.userContext = PermissionService.userContext;

            self.campaigns = [];

            if (!self.userContext) {
                return;
            }

            $scope.contextName = self.userContext.getCurrentContextName();

            // Check if the user has access to view the Campaigns page
            checkUserAccessToCampaignManagement();

            loadCampaigns();
            setupTable();
        };

        var setupTable = function () {
            $scope.campaignsTableParams = new NgTableParams({
                page: 1,
                count: Dashboard.NgTableParams.InitialCount
            }, {
                getData: function (params) {
                    return Dashboard.helpers.tableHelper
                        .sortAndFilter(params, $filter, self.campaigns);
                }
            });
        };

        /**
         * Check if the user has access to view the Users page
         */
        var checkUserAccessToCampaignManagement = function () {
            const userCanManageCampaigns = PermissionService
                .doesUserHavePermissionForContext(Dashboard.Models.Lookups.Permissions.ManageCampaigns,
                    self.userContext);

            if (!userCanManageCampaigns) {
                PermissionService.navigateToAccessDenied();
            }
        };

        /**
         * Loads the published campaigns for the current user/store
         */
        var loadCampaigns = function () {
            $scope.$root.isLoading = true;
            CampaignsService.getActiveCampaigns(self.userContext.StoreId, self.userContext.BrandId).then(
                function (result) {
                    self.campaigns = _.map(result.data.Campaigns, function (item) {
                        return new Dashboard.Models.Campaign().initialiseCampaignList(item, LocalisationService);
                    });
                    Dashboard.helpers
                        .tableHelper
                        .reloadTable($scope.campaignsTableParams,
                            self.campaigns);
                },
                function error(result) {
                    ErrorService.showError("An error occurred when loading the campaigns", result);
                }
            ).finally(
                function () {
                    $scope.$root.isLoading = false;
                }
            )
        };

        /**
         * Navigate to the campaign that was selected
         * @param campaignId {number}
         */
        $scope.selectCampaign = function (campaignId) {
            let reportioParams = self.userContext.StoreId
                ? DashboardConfig.ReportioStoreCampaignReportParams
                : DashboardConfig.ReportioBrandCampaignReportParams;
            const contextId = self.userContext.StoreId
                ? self.userContext.StoreId
                : self.userContext.BrandId;
            const selectedCampaign = _.findWhere(self.campaigns, { Id: campaignId });
            reportioParams = reportioParams.format(
                LocalisationService.formatDateTime(selectedCampaign.LaunchDate, "YYYY-MM-DD"),
                LocalisationService.formatDateTime(selectedCampaign.EndDate, "YYYY-MM-DD"),
                contextId,
                campaignId
            );
            $window.open("{0}{1}".format(DashboardConfig.ReportioUrl, reportioParams), "_blank");
        };

        /**
         * Cancel the ongoing campaign
         * @param campaign {object}
         */
        $scope.cancelCampaign = function (campaign) {
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'components/campaigns/cancelcampaign/cancelcampaignmodal.7d64b189.html',
                controller: 'CancelCampaignModalController',
                backdrop: 'static',
                resolve: {
                    campaign: function () {
                        return campaign;
                    }
                }
            });

            modalInstance.result.then(function (result) {
                if (!result) {
                    return;
                }
                CampaignsService.cancelCampaign(campaign.Id).then(function () {
                    loadCampaigns();
                    notify.success('The campaign was successfully cancelled');
                }, function error(result) {
                    ErrorService.showError('An error occurred when attempting to cancel a campaign', result);
                })
            })

        };

        self.initialise();
    }

    angular
        .module("dashboard")
        .component("currentCampaigns",
            {
                templateUrl: "components/campaigns/currentcampaigns/currentcampaigns.2543ad9b.html",
                bindings: {},
                controller: [
                    "$scope",
                    "$filter",
                    '$uibModal',
                    "PermissionService",
                    "CampaignsService",
                    "LocalisationService",
                    "ErrorService",
                    "notify",
                    "$state",
                    "$window",
                    "NgTableParams",
                    "DashboardConfig",
                    CurrentCampaignsController ]
            });
})();
